import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { TEMI, SLUG } from 'utils/endpoint'
import { api, CAS_DOMAIN } from 'utils'
import ListingAlgolia from 'components/ListingAlgolia'
import Head from 'next/head'
import { useRouter } from 'next/router'

const RisorseTema = ({ tema, pagina, statusCode }) => {
  if (!pagina) return <Error statusCode={statusCode} />

  const background = tema.main_image
    ? { backgroundImage: `url(${tema.main_image})` }
    : { backgroundColor: `black` }

  const filtriInitial = [tema.valore_attributo]

  const filtriDisponibili = [
    'visibilita', // custom
    'Ordine di scuola',
    'Classe',
    'Eta',
    'models', // custom
    'Tipo Strumento',
  ]

  const router = useRouter()
  const canonical = router.asPath.split('?')[0]

  return (
    <>
      {pagina ? (
        <>
          <MetaSeo seo={pagina.seo} />
          <Head>
            {tema.main_image ? <link rel="preload" href={tema.main_image} as="image" /> : null}
            <link rel="canonical" href={CAS_DOMAIN + canonical} />
          </Head>
          <main className="listing-page">
            <div
              className="w-container-fluid u-before-section u-background-image"
              style={background}
            >
              <div className="w-container">
                <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
              </div>

              <section className="listing-page__header">
                <div className="w-container">
                  <h1 className="listing-page__title">Risorse {tema.titolo}</h1>
                </div>
              </section>
            </div>
            <section className="listing-page__list-section section">
              <ListingAlgolia filtriInitial={filtriInitial} filtriDisponibili={filtriDisponibili} />
            </section>
          </main>
        </>
      ) : null}
    </>
  )
}

export async function getStaticPaths() {
  const response = await api.get(TEMI)
  const temi = response.data

  const paths = temi
    .map((t) => ({
      params: { slug: t.slug },
    }))
    .slice(0, 1)

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  try {
    const response = await api.get(`${TEMI}${SLUG}${slug}/`)
    const tema = response.data

    const pagina = tema.pagina

    const toolbarProps = { toolbarPage: pagina }

    return { props: { tema, pagina, ...toolbarProps, key: tema.id }, revalidate: 60 * 2 }
  } catch (error) {
    console.log(error)
    return {
      notFound: true,
    }
  }
}

export default RisorseTema
